import { render, staticRenderFns } from "./createPrescription.vue?vue&type=template&id=07aef724&scoped=true"
import script from "./createPrescription.vue?vue&type=script&lang=js"
export * from "./createPrescription.vue?vue&type=script&lang=js"
import style0 from "./createPrescription.vue?vue&type=style&index=0&id=07aef724&prod&scoped=true&lang=css"
import style1 from "./createPrescription.vue?vue&type=style&index=1&id=07aef724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07aef724",
  null
  
)

export default component.exports